import style from "./style.module.scss";
import Item from "./Item";

const vidTests = [
    {
        video: "./Videos/testimony1.mp4",
        videoText: [
            "Bij vhenga blijven we discreet. We laten",
            "nooit het vastgoed zien dat onze klanten",
            "hebben gekocht.",
            "Wij laten u wel een video zien die",
            "de klanten als vastgoed en als kanshebber zagen en",
            "ook hebben bezocht."
        ],
        text: "Na 35 jaar dag en nacht werken mocht het voor Bart en Gunther wat meer zijn. Na verschillende gesprekken en video's besloten ze in 2 dagen 2 droomwoningen te bezoeken. De rest is geschiedenis. Het werd droom 2."
    },
    {
        video: "/Videos/Amàre Beach Hotel Ibiza.mp4",
        videoText: ["Bij vhenga blijven we discreet. We laten", "nooit het vastgoed zien dat onze klanten", "hebben gekocht. Wij laten u wel een videoMaar wel een video die", "Wij laten u wel een video zien die", "de klanten als vastgoed als kanshebber zagen en", "ook hebben bezocht."],
        text: "Na 35 jaar dag en nacht werken mocht het voor Bart en Gunther wat meer zijn. Na verschillende gesprekken en video's besloten ze in 2 dagen 2 droomwoningen te bezoeken. De rest is geschiedenis. Het werd droom 2."
    }
];

function VidTestim() {
    return <div className={style.VidTestim}>
        {vidTests.map(test => <Item key={test.text} {...test} />)}
    </div>
}

export default VidTestim;